// extracted by mini-css-extract-plugin
var _1 = "EntityPhaseItem-moduleEntityPhaseItem__skgCK";
var _2 = "EntityPhaseItem-modulebackPart__rZ5wC";
var _3 = "EntityPhaseItem-moduleclickable__cWcBC";
var _4 = "EntityPhaseItem-moduledisabled__vlkmf";
var _5 = "EntityPhaseItem-modulefinished__xRAo3";
var _6 = "EntityPhaseItem-modulefrontPart__n8Se3";
var _7 = "EntityPhaseItem-moduleinProgress__TZ2uM";
var _8 = "EntityPhaseItem-moduleitem__uTaIg";
var _9 = "EntityPhaseItem-modulename__V5iYL";
var _a = "EntityPhaseItem-modulenotStarted__PCI7L";
var _b = "EntityPhaseItem-moduleselected__GgJlv";
export { _1 as "EntityPhaseItem", _2 as "backPart", _3 as "clickable", _4 as "disabled", _5 as "finished", _6 as "frontPart", _7 as "inProgress", _8 as "item", _9 as "name", _a as "notStarted", _b as "selected" }
